import { render } from "./AnnotationFilters.vue?vue&type=template&id=e268669e&scoped=true"
import script from "./AnnotationFilters.vue?vue&type=script&lang=js"
export * from "./AnnotationFilters.vue?vue&type=script&lang=js"

import "../../assets/scss/document_annotations.scss?vue&type=style&index=0&id=e268669e&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e268669e"]])

export default __exports__